<template>
  <v-container>
    <v-layout row wrap></v-layout>
    <iframe
      :src="src"
      ref="pdf"
      target="_blank"
      frameborder="0"
      style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px"
      height="100%"
      width="100%"
    ></iframe>
  </v-container>
</template>

<script>
/* eslint-disable */
//import jsPDF from "jspdf";
import { mapActions } from "vuex";
import pdf from "vue-pdf";
import moment from "moment";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import SettingService from "@/services/SettingService";
import PayrollService from "@/services/PayrollService";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      doc: "",
      src: "",
      ltdName: "",
      empcode: "",
      jsonData: [],
      income: "",
      incomeAmount: "",
      totalincome: 0,
      expenses: "",
      expensesAmount: "",
      totalexpenses: 0,
      space: "",
      spaceexpenses: "",
      spaceincome: "",
      data: null,
      pdfDocGen: null,
      header_table: [
        {
          text: "#",
        },
        {
          text: "รายการ",
        },
        {
          text: "หน่วยนับ",
        },
        {
          text: "จำนวน",
        },
      ],
    };
  },
  created() {
    this.doc = this.$route.params.docno;
    this.emp_code = this.$route.params.empcode;
    this.getCompany();
  },
  methods: {
    goto(path) {
      this.$router.push("/" + path);
    },
    back() {
      this.goto("payrolldoc/detail/" + this.doc);
    },
    async getPDFByEmpID() {
      let v = this;
      NProgress.start();
      try {
        let tmpResult = await PayrollService.getsilpPayroll(
          this.doc,
          this.emp_code
        );

        // gen items
        let rowIndex = 0;
        tmpResult.data.forEach((element) => {
          console.log(element);
          rowIndex++;
          v.code = element.code; //รหัสพนักงาน
          v.name = element.name.split("(")[0]; //ชื่อพนักงาน
          v.date = moment(element.toDate).format("DD/MM/YYYY"); //วันที่
          v.bankCode = element.bankCode; //เลขที่บัญชี
          v.departmentname = element.department_name; //ตำแหน่ง
          v.salary = v.thousandSep(element.salary); //เงินเดือน
          v.workingDate = element.workingDate; //จำนวนวันทำงาน
          v.deductSS = v.thousandSep(element.deductSS); //รายได้สุทธิ
          v.total_balance = v.thousandSep(element.total_balance); //รายได้สุทธิ
          v.accumulatedIncome = v.thousandSep(element.accumulatedIncome); //รายได้สะสม
          v.incomeCraft = element.incomeCraft; //ค่าฝีมือ
          v.incomePosition = element.incomePosition; //ค่าตำแหน่ง
          v.incomeSpecial = element.incomeSpecial; //ค่าพิเศษ
          v.cumulativeSS = v.thousandSep(element.cumulativeSS); //ประกันสะสม
          v.cumulativeTax = v.thousandSep(element.cumulativeTax); //ภาษีสะสม
          v.totalEarning = v.thousandSep(element.totalEarning); //รายได้รวม
          v.totalDeduct = v.thousandSep(element.totalDeduct); //รวมรายจ่าย
          v.incomeAndExpenses = element.incomeAndExpenses; //รวมรายจ่ายและรายได้
          v.deduct_tax = v.thousandSep(element.deduct_tax); //ภาษี
          v.otEarning = element.otEarning; //OT
          v.deductAbsent = element.deductAbsent; //หักเงินขาดรวม
          v.deductLate = element.deductLate; //หักเงินสายรวม
          v.deductLeave = element.deductLeave; //หักเงินลารวม
          v.deductOutbefore = element.deductOutbefore; //หักออกก่อนรวม

          v.income = "";
          v.incomeAmount = "";
          v.expenses = "";
          v.expensesAmount = "";
          v.spaceexpenses = "";
          v.spaceincome = "";
          v.space = "";
          //อัตรา
          if (v.salary != 0) {
            v.income += `อัตรา`;
            v.incomeAmount +=  v.salary;
          }else{
             v.income += `อัตรา`;
            v.incomeAmount += `0.00` ;
          }
          //เงินเดือน
          if (v.salary != 0) {
            v.income += `\nเงินเดือน`;
            v.incomeAmount += `\n` + v.salary;
          }else{
             v.income += `\nเงินเดือน`;
            v.incomeAmount += `\n0.00` ;
          }
           var result = [];

          v.incomeAndExpenses.forEach((element) => {
            if (!this[element.name] && !this[element.tranFlag]) {
              this[element.name] = {
                name: element.name,
                amount: 0,
                tranFlag: element.tranFlag,
              };
              result.push(this[element.name]);
            }
            this[element.name].amount += element.amount;
          }, Object.create(null));
          console.log(result);

          for (let index = 0; index < result.length; index++) {
            if (result[index].tranFlag === 0) {
              if (result[index].name) {
              }
               v.income += `\n` + result[index].name;
              //v.totalincome += result[index].amount;
               v.incomeAmount += `\n` + v.thousandSep(result[index].amount);
              v.spaceincome += `\n`;
            } else if (
              result[index].tranFlag !== 0 &&
              result[index].tranFlag !== 1
            ) {
              v.space += "";
            }
          }
          //  //เงินส่งเกิน
          //   v.income += `\nเงินส่งเกิน`;
          //   v.incomeAmount += `\n0.00` ;
          // //สวัสดิการอื่นๆ
          //   v.income += `\n\n\n\n\n\n\nสวัสดิการอื่นๆ`;
          //   v.incomeAmount += `\n\n\n\n\n\n\n0.00` ;
          //เงินรางวัลพิเศษ
           if (v.incomeSpecial > 0) {
            v.income += `\nเงินค่าฝีมือ`;
            v.incomeAmount += `\n` + v.thousandSep(v.incomeCraft);
          }else{
            v.income += `\nเงินค่าฝีมือ`;
            v.incomeAmount += `\n0.00`;
          }
          // //เงินได้จากหน้าที่
          if (v.incomePosition > 0) {
            v.income += `\nเงินได้จากหน้าที่`;
            v.incomeAmount += `\n` + v.thousandSep(v.incomePosition);
          }else{
            v.income += `\nเงินได้จากหน้าที่`;
            v.incomeAmount += `\n0.00` ;
          }
          //เงินรางวัลพิเศษ
           if (v.incomeSpecial > 0) {
            v.income += `\nเงินรางวัลพิเศษ`;
            v.incomeAmount += `\n` + v.thousandSep(v.incomeSpecial);
          }else{
            v.income += `\nเงินรางวัลพิเศษ`;
            v.incomeAmount += `\n0.00`;
          }

          // if (v.incomeCraft != 0) {
          //   v.income += `\nค่าฝีมือ`;
          //   v.incomeAmount += `\n` + v.thousandSep(v.incomeCraft);
          //   v.spaceincome += `\n`;
          // }
          // if (v.incomePosition > 0) {
          //   v.income += `\nค่าตำแหน่ง`;
          //   v.incomeAmount += `\n` + v.thousandSep(v.incomePosition);
          //   v.spaceincome += `\n`;
          // }
          // if (v.incomeSpecial > 0) {
          //   v.income += `\nค่าพิเศษ`;
          //   v.incomeAmount += `\n` + v.thousandSep(v.incomeSpecial);
          //   v.spaceincome += `\n`;
          // }
          if (v.otEarning > 0) {
            v.income += `\nค่าทำงานล่วงเวลา`;
            v.incomeAmount += `\n` + v.thousandSep(v.otEarning);
            v.spaceincome += `\n`;
          }else{
            v.income += `\nค่าทำงานล่วงเวลา`;
            v.incomeAmount += `\n0.00`;
          }

          //หักขาดงาน
          if (v.deductAbsent > 0) {
            v.expenses += `หักขาดงาน`;
            v.expensesAmount += `` + v.thousandSep(v.deductAbsent);
          } else {
            v.expenses += `หักขาดงาน`;
            v.expensesAmount += `0.00`;
          }
          // //เงินส่งขาด
          // v.expenses += `\nหักเงินส่งขาด`;
          // v.expensesAmount += `\n0.00`;
          //สาย
          if (v.deductLate > 0) {
            v.expenses += `\nหักมาสาย`;
            v.expensesAmount += `\n` + v.thousandSep(v.deductLate);
          } else {
            v.expenses += `\nหักมาสาย`;
            v.expensesAmount += `\n0.00`;
          }
          //หักของเสียหาย
          // v.expenses += `\nหักของเสียหาย`;
          // v.expensesAmount += `\n0.00`;
          //หักลาอื่นๆ
          if (v.deductLate > 0) {
            v.expenses += `\nหักลาอื่นๆ`;
            v.expensesAmount += `\n` + v.thousandSep(v.deductLeave);
          } else {
            v.expenses += `\nหักลาอื่นๆ`;
            v.expensesAmount += `\n0.00`; 
          }
          //หักสวัสดิการ
          // v.expenses += `\nหักสวัสดิการ`;
          // v.expensesAmount += `\n0.00`;
          //
          if (v.deductOutbefore > 0) {
            v.expenses += `\nหักออกก่อนรวม`;
            v.expensesAmount += `\n` + v.thousandSep(v.deductOutbefore);
          } else {
            v.expenses += `\nหักออกก่อนรวม`;
            v.expensesAmount += `\n0.00`;
          }
         

          for (let index = 0; index < result.length; index++) {
             if (result[index].tranFlag === 1) {
              v.expenses += `\n` + result[index].name;
              v.expensesAmount += `\n` + v.thousandSep(result[index].amount);
             // v.totalexpenses += result[index].amount;
              
            } else if (
              result[index].tranFlag !== 0 &&
              result[index].tranFlag !== 1
            ) {
              v.space += "";
            }
          }
          // if(v.totalincome > 0){
          //    v.income += `\nเงินได้อื่นๆ`;
          //    v.incomeAmount += `\n` + v.thousandSep(v.totalincome);
          // }
          // else{
          //     v.income += `\nเงินได้อื่นๆ`;
          //    v.incomeAmount += `\n0.00` ;
          // }
          //หักจ่ายอื่นๆ
          // if (v.totalexpenses > 0) {
          //   v.expenses += `\nหักจ่ายอื่นๆ`;
          //   v.expensesAmount += `\n` + v.thousandSep(v.totalexpenses);
            
          // } else {
          //   v.expenses += `\nหักจ่ายอื่นๆ`;
          //   v.expensesAmount += `\n0.00`;
            
          // }
          //หักประกันแรกเข้า
          // v.expenses += `\nหักประกันแรกเข้า`;
          // v.expensesAmount += `\n0.00`;
          

          //หักเงินกู้
          // v.expenses += `\nหักเงินกู้`;
          // v.expensesAmount += `\n0.00`;
          

          //หักกองทุนสำรองเลี้ยงชีพ
          // v.expenses += `\nหักกองทุนสำรองเลี้ยงชีพ`;
          // v.expensesAmount += `\n0.00`;
          
          //หักสมทบประกันสังคม
          if (v.deductSS > 0) {
            v.expenses += `\nหักสมทบประกันสังคม`;
            v.expensesAmount += `\n` + v.deductSS;
            
          } else {
            v.expenses += `\nหักสมทบประกันสังคม`;
            v.expensesAmount += `\n0.00`;
            
          }

          if (v.deduct_tax > 0) {
            v.expenses += `\nภาษี`;
            v.expensesAmount += `\n` +  v.thousandSep(v.deduct_tax);
            
          } else{
             v.expenses += `\nภาษี`;
            v.expensesAmount += `\n0.00`;
            
          }

          if (rowIndex === 1) {
            v.jsonData.push(v.genSlipJson("none"));
          } else {
            v.jsonData.push(v.genSlipJson("before"));
          }
        });
        this.createpdf();
      } catch (err) {
        console.log(err);
      }
      NProgress.done();
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    async getCompany() {
      NProgress.start();
      try {
        let tmpResult = await SettingService.getDataCompany();
        this.ltdName = tmpResult.data.content[0].companyname;
        this.getPDFByEmpID();
      } catch (err) {
        console.log(err);
      }
      NProgress.done();
    },
    createpdf() {
      let v = this;
      var pdfMake = require("pdfmake/build/pdfmake.js");
      //pdfMake.setFonts(fonts);
      pdfMake.fonts = {
        Sarabun: {
          normal:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVjJx26TKEr37c9WBJDnlQN9gk.ttf",
          bold: "https://fonts.gstatic.com/s/sarabun/v12/DtVmJx26TKEr37c9YK5sulwm6gDXvwE.ttf",
          italics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVhJx26TKEr37c9aBBJmnYI5gnOpg.ttf",
          bolditalics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVkJx26TKEr37c9aBBxJlks7iLSrwFUlw.ttf",
        },
      };
      // if (pdfMake.vfs == undefined) {
      //   var pdfFonts = require("pdfmake/build/vfs_fonts.js");
      //   pdfMake.vfs = pdfFonts.pdfMake.vfs;
      // }

      // pdfMake.fonts = {
      //   THSarabunNew: {
      //     normal: "THSarabunNew.ttf",
      //     bold: "THSarabunNew-Bold.ttf",
      //     italics: "THSarabunNew-Italic.ttf",
      //     bolditalics: "THSarabunNew-BoldItalic.ttf",
      //   },
      //   Roboto: {
      //     normal: "Roboto-Regular.ttf",
      //     bold: "Roboto-Medium.ttf",
      //     italics: "Roboto-Italic.ttf",
      //     bolditalics: "Roboto-MediumItalic.ttf",
      //   },
      // };

      let docDefinition = {
        content: this.jsonData,
        styles: {
          header: {
            fontSize: 20,
            bold: true,
            margin: [0, 0, 0, 3],
          },
          subheader: {
            fontSize: 14,
            bold: true,
          },
        },
        defaultStyle: {
          font: "Sarabun",
          fontSize: 14,
        },
      };
      this.pdfDocGen = pdfMake.createPdf(docDefinition);

      this.pdfDocGen.getDataUrl((data) => {
        this.src = data;
      });
    },
    genSlipJson(param) {
      let jSonResult = [
        {
          columns: [
            {
              text: "ใบจ่ายเงินเดือน",
              style: "header",
              fontSize: 16,
              alignment: "center",
              pageBreak: param,
            },
          ],
        },
        {
          columns: [
            {
              text: this.ltdName,
              style: "header",
              alignment: "center",
              fontSize: 16,
              
            },
          ],
        },
        {},
        {
          columns: [
            {
              text: "รหัส  " + this.code,
              style: "subheader",
              alignment: "left",
              width: 120,
            },
            {
              text: "ชื่อ-สกุล  " + this.name,
              style: "subheader",
              alignment: "left",
              width: 160,
            },
            {
              text: "แผนก  " + this.departmentname,
              style: "subheader",
              alignment: "left",
              width: 120,
            },
            {
              text: "เลขที่บัญชี  " + this.bankCode,
              style: "subheader",
              alignment: "left",
              width: 100,
            },
          ],
        },
        {
          columns: [
            {
              margin: [0, 10, 0, 0],
              table: {
                widths: [100, 50, 70, 100, 70],
                headerRows: 1,
                body: [
                  [
                    {
                      text: "รายได้" + "\n" + "Earnings",
                      alignment: "center",
                    },
                    {
                      text: "จำนวน" + "\n" + "Number",
                      alignment: "center",
                    },
                    {
                      text: "จำนวนเงิน" + "\n" + "Amount",
                      alignment: "center",
                    },
                    {
                      text: "รายการหัก" + "\n" + "Deductions",
                      alignment: "center",
                    },
                    {
                      text: "จำนวนเงิน" + "\n" + "Amount",
                      alignment: "center",
                    },
                  ],

                  [
                    { text: this.income },
                    { text:  "\n" + this.workingDate, alignment: "right" },
                    {
                      text: this.incomeAmount,
                      alignment: "right",
                    },
                    { text: this.expenses },
                    {
                      text: this.expensesAmount,
                      alignment: "right",
                    },
                  ],
                  [
                    {
                      text: "รวมเงินได้" + "\n" + "Total Earnings",
                      colSpan: 2,
                      alignment: "center",
                    },
                    { text: "" },
                    { text: "\n" + this.accumulatedIncome, alignment: "right" },
                    {
                      text: "รวมรายการหัก" + "\n" + "Total Deduction",
                      alignment: "center",
                    },
                    {
                      text: "\n" + this.totalDeduct,
                      
                      alignment: "right",
                    },
                  ],
                ],
              },
            },
            {
              margin: [5, 10, 0, 0],
              table: {
                widths: [80],
                headerRows: 1,
                body: [
                  [
                    {
                      text: "วันที่จ่าย" + "\n" + "Payroll Date",
                      margin: [ 5, 5, 5, 5 ],
                      alignment: "center",
                      
                    },
                  ],
                  [{ text: this.date, alignment: "center" }],
                ],
              },
            }, 
          ],
        },
        {
          columns: [
            {
              margin: [0, 5, 0, 0],
              table: {
                widths: [78, 78, 78, 78, 78],
                headerRows: 1,
                body: [
                  [
                    { text: "เงินได้สะสมต่อปี", alignment: "center" },
                    { text: "ภาษีสะสมต่อปี", alignment: "center" },
                    { text: "เงินสะสมกองทุนต่อปี", alignment: "center" },
                    { text: "เงินประกันสังคมต่อปี", alignment: "center" },
                    { text: "ค่าลดหย่อนอื่นๆ", alignment: "center" },
                  ],
                  [
                    { text: this.accumulatedIncome, alignment: "center" },
                    { text: this.cumulativeTax, alignment: "center" },
                    { text: "0.00", alignment: "center" },
                    { text: this.cumulativeSS, alignment: "center" },
                    { text: "0.00", alignment: "center" },
                  ],
                ],
              },
            },
            {
              margin: [5,-76, 0, 0],
              table: {
                widths: [80],
                headerRows: 1,
                body: [
                
                  [
                    {
                      text: "เงินรับสุทธิ" + "\n" + "Net To Pay",
                      margin: [ 5, 5, 5, 5 ],
                      alignment: "center",
                    },
                  ],
                  [{ text: this.total_balance, alignment: "center" }],
                ],
              },
            },
          ],
        },
      ];
      return jSonResult;
    },
  },
};
</script>

<style lang="stylus" scoped>
.print {
  width: 100%;
  height: 100%;

  table {
    width: 100%;
    border-bottom: 1px solid #F2F2F2;
  }

  table th {
    border-bottom: 1px solid #F2F2F2;
  }
}
</style>
